import React, { useContext } from "react";
import { Modal, Input, Heading, Flex, Button, Plus, TrashSimple, MNotification } from "@cisco/spaces-dash-lib-styleguide";
import { I18nContext } from "../../contexts/i18nContext";
import InputWithKeylist from "./input-with-keylist";

function AddMetadataPopup(props) {
  const i18n = useContext(I18nContext);
  const {
    showAddPopup,
    cancelAdd,
    isError,
    errorMessage,
    metadataToAddObj,
    metadataKeyList,
    onMetadataKeySelection,
    setMetadataToAddObj,
    isValid,
    isValidValue,
    // checkValidAdd,
    removeFromToAddObj,
    prepareAddMetadata,
    saveMetadata
  } = props;

  return (
    <Modal size="md" isOpen={showAddPopup} className="locRenamePopup">
      <Flex direction="vertical" gap={12}>
        <Heading as="h2" size="primary">
          {i18n.t("location-metadata-bulk.add-metadata-text")}
        </Heading>

        <Flex direction="vertical" gap={16}>
          {isError && errorMessage && <MNotification status="negative">{errorMessage}</MNotification>}

          <Flex direction="vertical" gap={16}>
            {metadataToAddObj?.map((metadatakey, i) => (
              <Flex className="metadata-block" key={metadatakey} gap={16} align="center">
                <div className="meta-component">
                  <div className="selection-wrapper">
                    <InputWithKeylist
                      onChange={(e) => {
                        onMetadataKeySelection(e, i);
                        isValidValue(e.target.value);
                      }}
                      value={metadataToAddObj[i]?.key}
                      placeholder={i18n.t("location-metadata-bulk.key-text")}
                      label={i18n.t("location-metadata-bulk.key-text")}
                      metadataKeyList={metadataKeyList}
                      required
                    />
                  </div>
                </div>
                <div className="meta-component-value">
                  <div className="user-input-wrp">
                    <Input
                      label={i18n.t("location-metadata-bulk.value-text")}
                      value={metadataToAddObj[i]?.values[0]}
                      onChange={(event) => {
                        const newMetadataToAddObj = [...metadataToAddObj];
                        newMetadataToAddObj[i].values[0] = event.target.value;
                        setMetadataToAddObj(newMetadataToAddObj);
                        isValid(newMetadataToAddObj);
                      }}
                      placeholder={i18n.t("location-metadata-bulk.value-text")}
                      className="inputText-add input-text"
                      maxLength="100"
                      required
                    />
                  </div>
                </div>
                <div
                  className="meta-component-delete"
                  style={{
                    display: metadataToAddObj && metadataToAddObj.length > 1 ? "block" : "none"
                  }}
                >
                  <Button icon={<TrashSimple size={16} weight="bold" />} kind="tertiary" onClick={() => removeFromToAddObj(i)} />
                </div>
              </Flex>
            ))}
          </Flex>

          <div>
            <Button icon={<Plus size={16} weight="bold" />} kind="secondary" onClick={prepareAddMetadata}>
              {i18n.t("location-metadata-bulk.add-metadata-text")}
            </Button>
          </div>
        </Flex>

        <Flex justify="flex-end">
          <Button.Group>
            <Button kind="tertiary" onClick={cancelAdd} id="metadata-cancel-button">
              {i18n.t("business-location-details.cancel-text")}
            </Button>
            <Button onClick={saveMetadata} id="metadata-save-button">
              {i18n.t("hierarchy-nodes.save-text")}
            </Button>
          </Button.Group>
        </Flex>
      </Flex>
    </Modal>
  );
}

export default AddMetadataPopup;
